import { decodePerlingoNewlines } from './newlines'

export const isProbablyHtml = (value: string) => /<\/?[a-z][\s\S]*>/i.test(value)

const decodeHtmlEntities = (value: string) => {
  if (typeof document !== 'undefined') {
    try {
      const el = document.createElement('textarea')
      el.innerHTML = value
      return el.value
    } catch {
      // fallthrough
    }
  }

  // Minimal fallback for non-DOM environments.
  return value
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#0*39;/g, "'")
    .replace(/&#0*8203;/g, '')
    .replace(/&ZeroWidthSpace;|&zwsp;/gi, '')
}

export const htmlToPlainText = (html: string) => {
  const withNewlines = html
    .replace(/<br\s*\/?\s*>/gi, '\n')
    .replace(/<\/?div\b[^>]*>/gi, '\n')
    .replace(/<\/?p\b[^>]*>/gi, '\n')

  const stripped = withNewlines.replace(/<[^>]*>/g, '')
  const decoded = decodeHtmlEntities(stripped)

  // Remove zero-width spaces used for rendering empty lines.
  return decoded.replace(/\u200B/g, '')
}

export const normalizeTextContentToPlain = (raw: string) => {
  const decoded = decodePerlingoNewlines(raw || '')
  if (!decoded) return ''
  if (!isProbablyHtml(decoded)) return decoded
  return htmlToPlainText(decoded)
}
